import axios from '@/libs/api.request'
// 获取批量信息
export const getList = (data) => {
  return axios.request({
    url: '/finance/ddu/hq/detail/index',
    method: 'post',
    data
  })
}
// 获取单个信息
export const getDetails = (id) => {
  return axios.request({
    url: `/finance/dblChargingType/${id}`,
    method: 'GET'
  })
}
// 删除单个信息
export const del = (id) => {
  return axios.request({
    url: `/finance/dblChargingType/${id}`,
    method: 'DELETE'
  })
}
// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/finance/dblChargingType/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  return axios.request({
    url: '/finance/dblChargingType',
    method: 'POST',
    data
  })
}

export const recalculate = (data) => {
  return axios.request({
    url: '/finance/ddu/hq/detail/recalculate',
    method: 'POST',
    data
  })
}

export const sync = () => {
  return axios.request({
    url: `/finance/ddu/hq/detail/sync`,
    method: 'GET'
  })
}

export const createBill = (data) => {
  return axios.request({
    url: '/finance/ddu/hq/detail/createBill',
    method: 'POST',
    data
  })
}

export const addFee = (data) => {
  return axios.request({
    url: '/finance/ddu/hq/detail/addFee',
    method: 'POST',
    data
  })
}


export const pushToTMS = (data) => {
  return axios.request({
    url: '/finance/ddu/hq/detail/pushToTMS',
    method: 'POST',
    data
  })
}